"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeFetchableStatic = exports.IkeCollectionLoaderFromState = void 0;
var __1 = require("..");
var IkeCollectionLoaderFromState = /** @class */ (function () {
    function IkeCollectionLoaderFromState(collections, forms, captures, calibrations) {
        var _this = this;
        this.Collection = {
            getByRevision: function (revision) { return _this.getBy(_this.collections, 'revision', revision); },
            getModel: function (revision) { return _this.getOrCreate(_this.collectionModel, 'revision', revision, function () {
                var collectionJson = _this.Collection.getByRevision(revision).value;
                var form = _this.Form.getModel(collectionJson.formversion).value;
                var collection = __1.IkeModel.Collection.read(collectionJson, form, _this);
                return collection;
            }); }
        };
        this.CollectionSummary = {
            getById: function (objectId) { return _this.getSummary('objectId', objectId); },
            getByUuid: function (uuid) { return _this.getSummary('uuid', uuid); }
        };
        this.Form = {
            getById: function (id) { return _this.getBy(_this.forms, 'objectId', id); },
            getByRevision: function (revision) { return _this.getBy(_this.forms, 'version', revision); },
            getModel: function (revision) { return _this.getOrCreate(_this.formModel, 'version', revision, function () { return __1.IkeModel.Form.read(_this.Form.getByRevision(revision).value); }); }
        };
        this.Capture = {
            getById: function (objectId) { return _this.getBy(_this.captures, 'objectId', objectId); },
            getByUuid: function (uuid) { return _this.getBy(_this.captures, 'uuid', uuid); }
        };
        this.Calibration = {
            getById: function (objectId) { return _this.getBy(_this.calibrations, 'objectId', objectId); }
        };
        /** Will fetching objects throw errors if they cannot be found */
        this.isMissingAllowed = false;
        this.setCollections(collections);
        this.setForms(forms);
        this.setCaptureCalibration(captures, calibrations);
    }
    IkeCollectionLoaderFromState.prototype.fromState = function (state) {
        this.setCollections(state.Collection);
        this.setForms(state.Form);
        this.setCaptureCalibration(state.Capture, state.Calibration);
    };
    IkeCollectionLoaderFromState.prototype.setCollections = function (collections) {
        if (collections === void 0) { collections = []; }
        this.collections = collections.slice();
        this.collectionModel = [];
    };
    IkeCollectionLoaderFromState.prototype.setForms = function (forms) {
        if (forms === void 0) { forms = []; }
        this.forms = forms.slice();
        this.formModel = [];
    };
    IkeCollectionLoaderFromState.prototype.addForm = function (form) {
        this.addUnique(this.forms, form, 'version');
    };
    IkeCollectionLoaderFromState.prototype.setCaptureCalibration = function (captures, calibrations) {
        if (captures === void 0) { captures = []; }
        if (calibrations === void 0) { calibrations = []; }
        this.captures = captures.slice();
        this.calibrations = calibrations.slice();
    };
    IkeCollectionLoaderFromState.prototype.addCaptureCalibration = function (capture, calibration) {
        this.addUnique(this.captures, capture, 'uuid');
        if (calibration != null) {
            this.addUnique(this.calibrations, calibration, 'objectId');
        }
    };
    IkeCollectionLoaderFromState.prototype.setIsMissingAllowed = function (isMissingAllowed) {
        this.isMissingAllowed = isMissingAllowed;
    };
    /** Add a item to the array only if it doesn't exist already */
    IkeCollectionLoaderFromState.prototype.addUnique = function (objects, obj, key) {
        var value = obj[key];
        if (objects.find(function (f) { return f[key] === value; })) {
            return;
        }
        objects.push(obj);
    };
    IkeCollectionLoaderFromState.prototype.getBy = function (objects, key, value) {
        var foundItem = objects.find(function (t) { return t[key] === value; });
        // IkeRest will return null, so should this
        if (foundItem == null && this.isMissingAllowed !== true) {
            throw new Error("Unable to fetch ".concat(key, ":").concat(value));
        }
        return new IkeFetchableStatic(foundItem);
    };
    IkeCollectionLoaderFromState.prototype.getOrCreate = function (objects, key, value, create) {
        try {
            return this.getBy(objects, key, value);
        }
        catch (e) {
            objects.push(create());
            return this.getBy(objects, key, value);
        }
    };
    IkeCollectionLoaderFromState.prototype.getSummary = function (key, value) {
        var collection = this.getBy(this.collections, key, value).value;
        if (collection == null) {
            throw new Error("Unable to find collection: ".concat(key, ":").concat(value));
        }
        var collectionModel = this.Collection.getModel(collection.revision).value;
        if (!collectionModel) {
            throw new Error("Unable to get collection model ".concat(collection.revision));
        }
        return new IkeFetchableStatic(__1.IkeModel.Collection.summary(collectionModel));
    };
    return IkeCollectionLoaderFromState;
}());
exports.IkeCollectionLoaderFromState = IkeCollectionLoaderFromState;
var IkeFetchableStatic = /** @class */ (function () {
    function IkeFetchableStatic(obj) {
        this.hasFetched = true;
        this.isFetching = false;
        this.lastFetch = Date.now();
        this.error = null;
        this.value = null;
        this.value = obj;
        this.promise = Promise.resolve(obj);
    }
    IkeFetchableStatic.prototype.refetch = function () {
        return this.promise;
    };
    IkeFetchableStatic.prototype.reset = function () {
        // ignore
    };
    IkeFetchableStatic.prototype.fetch = function () {
        return this.promise;
    };
    IkeFetchableStatic.prototype.init = function (value) {
        this.value = value;
        this.promise = Promise.resolve(value);
    };
    return IkeFetchableStatic;
}());
exports.IkeFetchableStatic = IkeFetchableStatic;
//# sourceMappingURL=collection.loader.js.map